export default {
  shouldSkipShippingAndPickup:
  (checkoutPageState) => !!checkoutPageState?.bagItems?.hasOnlyEGiftCard,
  shouldSkipPaymentAndBilling:
  (checkoutPageState) => {
    const { orderTotals } = checkoutPageState || {};
    const { grandTotal = 0, promoAmount = 0, cartTotalAmount = 0 } = orderTotals || {};
    const promoDiscount = Math.abs(promoAmount);
    const isPaymentCoveredByPromo = (
      grandTotal === 0
      && promoDiscount !== 0
      && promoDiscount === cartTotalAmount
    );
    return isPaymentCoveredByPromo;
  },
};
